import { Col, Row } from "@/base/index";
import { useBreakpoint } from "@/base/utils/index";
import { SectionPage } from "@/components/section-page";
import { cx } from "antd-style";
import type { AppHeaderLayoutProps } from "../types/index";
import { useAppHeaderLayoutStyles } from "./app-header-layout.styles";

export const AppHeaderLayout = ({
  className,
  logo,
  buttonMenu,
  menu,
  signin,
  userMenu,
  cart,
}: AppHeaderLayoutProps) => {
  const screens = useBreakpoint();
  const { styles } = useAppHeaderLayoutStyles();

  return (
    <SectionPage
      classNames={{
        section: cx(styles.section, className),
        body: styles.body,
      }}
    >
      <Row
        align="middle"
        style={{ width: "100%" }}
        gutter={[12, 12]}
        wrap={false}
      >
        {!screens.lg && buttonMenu && <Col flex="none">{buttonMenu}</Col>}
        <Col xs={{ flex: 1 }} lg={{ flex: "none" }}>
          {logo}
        </Col>
        {screens.lg && menu && <Col flex={1}>{menu}</Col>}
        {signin && <Col flex="none">{signin}</Col>}
        {userMenu && <Col flex="none">{userMenu}</Col>}
        {cart && <Col flex="none">{cart}</Col>}
      </Row>
    </SectionPage>
  );
};
